export function AppWrapper({ children }) {
  return <div className="w-max-96 mx-auto min-h-screen font-base">{children}</div>;
}
